var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailPurple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Send voucher icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Send-voucher-icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "heroicons:envelope"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "ViewBox",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5,6.25 C35.2614237,6.25 37.5,8.48857625 37.5,11.25 L37.5,28.75 C37.5,31.5114237 35.2614237,33.75 32.5,33.75 L7.49999998,33.75 C4.73857625,33.75 2.49999998,31.5114237 2.49999998,28.75 L2.50124998,11.6975 L2.49999998,11.6566667 L2.49999998,11.25 L2.50249998,11.21875 L2.50611913,11.0004496 C2.6320879,8.43763212 4.68763212,6.3820879 7.25044957,6.25611913 L7.49999998,6.25 L32.5,6.25 Z M35,15.9875 L22.6222222,23.6043058 C21.0143411,24.5946747 18.9856589,24.5946747 17.3783541,23.6046606 L4.99999998,15.98875 L4.99999998,28.75 C4.99999998,30.0679522 6.01984724,31.1477064 7.31342207,31.2431428 L7.49999998,31.25 L32.5,31.25 C33.8807119,31.25 35,30.1307119 35,28.75 L35,15.9875 Z M32.5,8.75 L7.49999998,8.75 C6.11928813,8.75 4.99999998,9.86928813 4.99999998,11.25 L4.99999998,11.6566667 C4.99999998,12.5247356 5.45000061,13.3305785 6.18831255,13.7853394 L18.6888889,21.4756942 C19.4928294,21.9708786 20.5071706,21.9708786 21.3115845,21.4754027 L33.8111111,13.7840275 C34.5499994,13.3289118 35,12.523069 35,11.655 L35,11.25 L34.9931428,11.0634221 C34.8977064,9.76984724 33.8179522,8.75 32.5,8.75 Z",
    id: "Shape",
    fill: "#821BB8",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailPurple);
export default __webpack_public_path__ + "static/media/email-purple.f19a5f8d5946937017e219ca56867e9a.svg";
export { ForwardRef as ReactComponent };